export const environment = {
  allowImageExt: '.jpg,.png,.jpeg',
  dockerCompose: false,
  featureFlags: { longPolling: false },
  firebaseConfig: {
    apiKey: 'AIzaSyALgAqHtZqifUrXNJPtRQdFHnkVbecUFuQ',
    appId: '1:23099111493:web:43b245dd93c97252610b2c',
    authDomain: 'terrific-live.firebaseapp.com',
    measurementId: 'G-RK6B7C4WT5',
    messagingSenderId: '23099111493',
    projectId: 'terrific-live',
    storageBucket: 'terrific-live.appspot.com',
  },
  maxUplodedImageSize: 5_000_001,
  platformServiceUrl: 'https://app-terrific-live-prod.terrific.live',
  production: true,
  terrificWebsiteUrl: 'https://terrific.live',
  useEmulators: false,
};
